module.exports = "/shifts/components/availabilitiesTabComponent-d3219f.html";